<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowRight } from "@mdi/js"

export default {
  name: "ArrowRightIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowRight,
    }
  }
}
</script>
